import axios from 'axios';
import { BASE_URL } from '../hook/baseUrl';

const getCookie = (name) => {
  const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return m ? m.pop() : '';
};

export const apiClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  timeout: 30000, // 30 saniye timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    // Let the browser set multipart/form-data boundary automatically.
    if (config.headers?.delete) {
      config.headers.delete('Content-Type');
    } else if (config.headers) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
  }

  const unsafe = ['post', 'put', 'patch', 'delete'];
  if (unsafe.includes((config.method || '').toLowerCase())) {
    const csrftoken = getCookie('csrftoken');
    if (csrftoken) config.headers['X-CSRFToken'] = csrftoken;
  }
  return config;
});

// Single-flight refresh and retry on 401
let isRefreshing = false;
let pendingQueue = [];
let redirectInProgress = false;

const processQueue = (error) => {
  const queue = pendingQueue;
  pendingQueue = [];
  queue.forEach(({ resolve, reject, config }) => {
    if (error) reject(error);
    else resolve(apiClient(config));
  });
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalRequest = error.config || {};
    const url = (originalRequest.url || '').toString();

    if (status === 401) {
      // Skip redirect for auth endpoints or when already on login page
      const isAuthEndpoint = url.includes('users/token/') || url.includes('users/csrf/') || url.includes('users/token/logout/');
      const onLoginPage = (window.location.pathname || '').startsWith('/authentication');
      if (isAuthEndpoint || onLoginPage) {
        return Promise.reject(error);
      }
      try {
        // Broadcast a global session-expired event (modal göstermek için)
        window.dispatchEvent(new CustomEvent('auth:expired'));
      } catch (_) {}
      // Otomatik yönlendirme kaldırıldı; modal üzerinden kullanıcıyı yönlendireceğiz
    }

    return Promise.reject(error);
  }
);

export default apiClient;

